import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { founder, LOGO } from '../../data/content';
import { shopHref } from '../../utils/hosts';
import { ease } from '../../core/format/motion';
type Props = {
  children: ReactNode;
  wide?: boolean;
};

/** Het kader van inloggen, de tweede stap en 2FA instellen: foto links, één kolom rechts. */
export function AuthShell({
  children,
  wide = false
}: Props) {
  const reduce = useReducedMotion();
  return <div className="admin-root grid min-h-screen min-h-dvh w-full bg-sand lg:grid-cols-2" data-id="element-3854" data-mp="1x6alit59eru5">
      <div className="relative hidden overflow-hidden lg:block" data-id="element-3855" data-mp="1x8mx8okfc5yr">
        <img src={founder.atWork} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-3856" data-mp="2b5jogr4gfpg6" />
        <div className="absolute inset-0 bg-ink/35" aria-hidden="true" data-id="element-3857" data-mp="267i6yamofy6t" />
        <p className="absolute bottom-10 left-10 right-10 max-w-md font-display text-3xl font-light leading-snug text-shell" data-id="element-3858" data-mp="gr91ko7f75d1">
          Alles van je salon en webshop op één plek.
          <span className="italic" data-id="element-3859" data-mp="3g5ygmn1znd95"> Zonder technische kennis.</span>
        </p>
      </div>

      <main className="flex items-center justify-center px-6 py-12" data-id="element-3860" data-mp="3l4jl4yo9wj3e">
        <motion.div initial={reduce ? false : {
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease
      }} className={`w-full ${wide ? 'max-w-md' : 'max-w-sm'}`} data-id="element-3861" data-mp="3l2oy9etfygwo">
          <div className="flex items-center gap-3" data-id="element-3862" data-mp="2rbpqono2qw5">
            <img src={LOGO} alt="Beauty Bewust" className="h-11 w-auto mix-blend-multiply" data-id="element-3863" data-mp="2qjzzugr3nds" />
            <span className="rounded-full bg-ink px-2 py-0.5 text-[11px] text-shell" data-id="element-3864" data-mp="7o23v6fwvcex">Beheer</span>
          </div>
          {children}
          <a href={shopHref('/')} className="mt-6 inline-block text-[13px] text-muted hover:text-ink" data-id="element-3865" data-mp="ho2t190gomr1">
            <span aria-hidden="true" data-id="element-3866" data-mp="2egmd1kktc1cw">← </span>Terug naar de website
          </a>
        </motion.div>
      </main>
    </div>;
}